module.exports = __webpack_public_path__ + "static/media/thewest-w-gradient.14ae6741.png";